import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'

import SectionHeader from 'components/attacks/create/SectionHeader'
import SectionTitle from 'components/attacks/create/SectionTitle'
import { Name, Label, Description } from 'components/attacks/create/styles'
import RandomTrigger from 'components/attacks/create/trigger/RandomTrigger'
import { Accordion, Body, Footer } from 'components/common/Accordion'
import BooleanField from 'components/common/BooleanField'
import DayPicker from 'components/common/DayPicker'
import Flex from 'components/common/Flex'
import InputSwitch from 'components/common/InputSwitch'
import theme from 'theme'

export default function Schedule({ expanded, disabled, activateStep }) {
  const { setFieldValue, values } = useFormikContext()
  const { isScheduleEnabled, activeDays } = values

  return (
    <Accordion
      css={{ marginBottom: theme.space[3] }}
      disabled={disabled}
      expanded={expanded}
    >
      <SectionHeader
        data-test-schedule-section-header
        onClick={() => disabled || activateStep()}
      >
        <SectionTitle
          icon="calendar"
          info="Unleash now or schedule for later."
          title="Schedule Scenario"
        />
      </SectionHeader>
      <Body css={{ padding: theme.space[5] }}>
        <Flex
          column
          css={{
            padding: theme.space[5]
          }}
        >
          <Flex>
            <Name>
              <Label>Schedule</Label>
              <Description>Run this Scenario at a future date</Description>
            </Name>
            <BooleanField currentValue={isScheduleEnabled}>
              <InputSwitch
                data-test-schedule-enabled
                checked={isScheduleEnabled}
                onChange={() =>
                  setFieldValue('isScheduleEnabled', !isScheduleEnabled)
                }
              />
            </BooleanField>
          </Flex>
          {isScheduleEnabled && (
            <Flex column>
              <Flex
                css={{
                  marginTop: theme.space[4],
                  cursor: 'pointer',
                  '& label': {
                    cursor: 'pointer'
                  }
                }}
              >
                <Name>
                  <Label>Days Scenario will run</Label>
                  <Description>Select at least one day</Description>
                </Name>
                <Flex css={{ width: '50%' }}>
                  <DayPicker
                    activeDays={activeDays}
                    buttonSize={theme.space[6]}
                    css={{
                      '& button': {
                        fontSize: theme.fontSizes[1]
                      }
                    }}
                    onChange={(day) => {
                      setFieldValue(
                        'activeDays',
                        activeDays.some((activeDay) => activeDay === day)
                          ? activeDays.filter((activeDay) => activeDay !== day)
                          : activeDays.concat(day)
                      )
                    }}
                  />
                </Flex>
              </Flex>
            </Flex>
          )}
        </Flex>
      </Body>
      <Footer>{isScheduleEnabled && <RandomTrigger />}</Footer>
    </Accordion>
  )
}

Schedule.propTypes = {
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
  activateStep: PropTypes.func,
  previousSchedule: PropTypes.object
}

Schedule.defaultProps = {
  activateStep: () => {}
}
